export const ACCESS_TOKEN_COOKIE_NAME = 'stashAccessToken';
export const REFRESH_TOKEN_COOKIE_NAME = 'stashRefreshToken';
export const USER_ID_COOKIE_NAME = 'stashUserID';
export const UUID_COOKIE_NAME = 'stashUUID';
export const USER_CREATED_AT = 'stashUserCreatedAt';
export const UTM_CONTENT = 'utm_content';

export const SESSION_TIMEOUT_INTERVAL =
	window.Stash.env === 'production'
		? 1000 * 60 * 20 // 20 minutes
		: 1200000;

export const SESSION_TIMEOUT_INTERVAL_SECS = SESSION_TIMEOUT_INTERVAL / 1000;
